import HeyGenPlayer from './HeyGenVHPlayer/HeyGenPlayer';
import useDevMode from '@vh/utility/useDevMode';
import React, { useMemo } from 'react';
import UnityVHPlayer from '@vh/components/VHPlayer/UnityVHPlayer/UnityVHPlayer';
import DevVHPlayer from '@vh/components/VHPlayer/DevVHPlayer/DevVHPlayer';
import { useLocation } from 'react-router-dom';
import BasicVHPlayer from '@vh/components/VHPlayer/BasicVHPlayer/BasicVHPlayer';
import RealtimeOpenAIPlayer from '@vh/components/VHPlayer/RealtimeOpenAIPlayer/RealtimeOpenAIPlayer';

/**
 * @type {React.FC<{
 * onLoaded: () => void;
 * rootDirectory: string;
 * vhId: number;
 * playerAreaRef: React.RefObject<HTMLDivElement> | null;
 * avatarName: string;
 * environment: object;
 * clothing?: string;
 * playerType?: 'heygen' | 'basic' | '3D' | 'voice_focused';
 * }>}
 * */
const VHPlayerSelector = ({
  onLoaded,
  rootDirectory,
  vhId,
  playerAreaRef,
  avatarName,
  environment,
  clothing,
  playerType,
}) => {
  const devMode = useDevMode();
  const { search } = useLocation();
  const playerOverride = useMemo(() => {
    const params = new URLSearchParams(search);
    return params.get('player');
  }, [search]);

  if (
    playerType === 'voice_focused' ||
    playerOverride === 'voice_focused'
  ) {
    return <RealtimeOpenAIPlayer onLoaded={onLoaded} vhId={vhId} />;
  }

  if (playerType === 'heygen' || playerOverride === 'heygen') {
    return <HeyGenPlayer onLoaded={onLoaded} vhId={vhId} />;
  }

  if (playerType === 'basic' || playerOverride === 'basic') {
    return <BasicVHPlayer onLoaded={onLoaded} vhId={vhId} />;
  }

  if (devMode) {
    return <DevVHPlayer onLoaded={onLoaded} vhId={vhId} />;
  }

  return (
    <UnityVHPlayer
      onLoaded={onLoaded}
      rootDirectory={rootDirectory}
      patientId={vhId}
      playerAreaRef={playerAreaRef}
      avatarName={avatarName}
      environment={environment}
      clothing={clothing}
    />
  );
};

export default VHPlayerSelector;
